// Define the custom styles
const customStyles = {
  productCards: `
    :host {
      /* Add host-specific styles if needed */
    }
  `,
  general: `
    .select-wrap .selector {
      border: none;
      border-bottom: 1px solid #000;
      padding-bottom: 12px;
      font-weight: var(--font-weight-light);
      background-image: url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 1L7 7L1 1' stroke='black' style='stroke:black;stroke-opacity:1;' stroke-linecap='square'/%3E%3C/svg%3E%0A") !important;
    }

    #status-app * {
      text-transform: lowercase;
      font-weight: var(--font-weight-light);
    }

    #status-app .me-button {
      display: none;
    }

    .product-info.item {
      justify-content: flex-start;
      align-items: flex-start;
    }

    .product-info.item .product-title {
      font-weight: var(--font-weight-light);
    }

    button.favorite-button {
      top: 0;
      right: 0 !important;
    }

    .login-heading {
      font-size: 17px;
    }

    #status-app .icon-wrap {
      background-color: #fff;
      color: #171722;
    }
  `,
  productPage: `
    .favorite-button svg path {
      stroke: #fff !important;
    }

    .favorite-button.active svg path {
      fill: #fff !important;
    }
  `,
};

// Function to apply styles to elements
const applyStyles = (elements, styles) => {
  elements.forEach(element => {
    const shadowRoot = element.shadowRoot;
    if (shadowRoot) {
      const styleElement = document.createElement('style');
      styleElement.textContent = styles;
      shadowRoot.appendChild(styleElement);
    }
  });
};

// Function to handle click event
const handleCartDrawerClick = (event) => {
  const productCartItemInfo = event.target.closest('.product-cart-item-info');
  if (productCartItemInfo) {
    const removeButton = productCartItemInfo.querySelector('.remove');
    if (removeButton) {
      removeButton.click();
    }
  }
};

// Function to apply all custom styles
const applyAllCustomStyles = () => {
  const cartDrawerElements = document.querySelectorAll('.cart-drawer status-save-button, .main-cart-page status-save-button');

  if (cartDrawerElements.length > 0) {
    cartDrawerElements.forEach(element => {
      element.addEventListener('click', handleCartDrawerClick);
    });
  }

  // wait for status to be injected into the DOM
  setTimeout(() => {
    const statusAppElement = document.querySelector('status-app');
    const statusWishlistButton  = document.querySelector('.product-add-to-cart-container status-favorite-button');
    
    if (statusAppElement) {
      applyStyles([statusAppElement], customStyles.general);

      if (statusWishlistButton) {
        applyStyles([statusWishlistButton], customStyles.productPage);
      }
    }
  }, 120);
};

// Event listener for the initial load
document.addEventListener('status:loaded', applyAllCustomStyles);

// Custom event to reapply styles
document.addEventListener('reapplyStyles', applyAllCustomStyles);

// Function to dispatch custom event
const reapplyStyles = () => {
  const event = new CustomEvent('reapplyStyles');
  document.dispatchEvent(event);
};

document.addEventListener("line-item:change:end", function (evt) {
  reapplyStyles();
});

document.addEventListener("cart:item-added", function (evt) {
  reapplyStyles();
});

document.addEventListener("cart-drawer:open", function (evt) {
  window.dispatchEvent(new Event('resize'));
});